// Packages
import styled from "styled-components";
import tw from "twin.macro";

export const StyledTypography = styled.p.attrs({
  className: "",
})`
  // Variant
  ${(props) => {
    switch (props.variant) {
      case "h1":
        return tw`text-xl leading-5`;
      case "h2":
        return tw`text-lg leading-5 leading-tight`;
      case "h3":
        return tw`font-light text-sm `;
      case "h4":
        return tw`font-light text-xs`;
      case "h5":
        return tw`text-xs leading-tight`;
      case "h6":
        return tw`text-xs`;
      case "p":
        return tw`text-base`;
      case "span":
        return tw`text-xxs`;
      default:
        return tw`text-base`;
    }
  }}
`;
